<template>
    <svg viewBox="0 0 30.76 30.76">
        <circle cx="15.38" cy="15.38" r="8" :stroke="color" stroke-width="4" fill="none" />
    </svg>
</template>

<script>
export default {
    props: ['color']
}
</script>